import React, { useContext } from 'react';
import { localize } from '/react4xp/mixins/helpers';
import Button from '/react4xp/mixins/ui/button/button';

interface CollapsedButtonProps {
    openChat: () => void;
    translations: any;
}

const CollapsedButton = ({ openChat, translations }: CollapsedButtonProps) => {
    return (
        <Button
            onClick={openChat}
            className="virtual-ai-toggle-button"
            color="light-blue"
        >
            <span>{localize('ii', translations)}</span>
        </Button>
    );
};

export default CollapsedButton;
